export const coachResultStatus = [ 'Ausstehend', 'Bewertet', 'Freigegeben', 'Wiedervorlage' ]

export const feedbackStatus    = [ 'Ausstehend', 'Gesendet', 'Gelesen', 'Zugesagt', 'Abgesagt', 'Nicht zustellbar' ]

export const clothingSizes     = [ 'XS', 'S', 'M', 'L', 'XL', 'XXL' ]

export const refereeCategories = [ 'A', 'B', 'C' ]

export const relationTypes     = [ 'Prio A', 'Prio B', 'Prio C', 'Block' ]

export const timeIntervals     = [ 'Minuten', 'Stunden', 'Tage' ]